const TEXTS = {
  tabLabel: 'Business',
  disclaimerTitle: 'Enter the business number or name to verify your business.',
  disclaimerBody:
    'Once verified, the business details fields will be auto-filled. If you edit these fields, they can no longer be verified.',
  businessDetailsSection: 'Business Details',
  businessLegalName: 'Business Legal Name',
  businessTradingName: 'Business Trading Name',
  bnLabelAU: 'Business Number (ABN)',
  bnLabelNZ: 'Business Number (NZBN)',
  cnLabelAU: 'Company Number (ACN)',
  cnLabelNZ: 'Company Number (NZCN)',
} as const;

export default TEXTS;
